import styled from "styled-components";
import GuideText from "@FRAMEWORK/ui/desktop/text/GuideText";
import Accessibility from "@FRAMEWORK/ui/desktop/text/Accessibility";

const BlueText = styled.span`
	color: var(--blue-color);
`;
const EditorText = styled.p`
	font-size: 15px;
	color: var(--default-color);
	line-height: 1.6;
	word-break: keep-all;
`;

const Ellipsis = (line: number) => `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${line};
    -webkit-box-orient: vertical;
`;

const RedText = styled.span`
	color: var(--red-color);
`;

const Title = styled.h2`
	font-family: "PT-medium";
	font-size: var(--title-size);
	color: var(--emp-color);
`;

const SubTitle = styled.h3`
	font-family: "PT-medium";
	font-size: var(--large-size);
	color: var(--emp-color);
	line-height: var(--large-size);
`;

const MinorTitle = styled.h4`
	font-family: "PT-medium";
	font-size: var(--medium-size);
	color: var(--emp-color);
`;

export {BlueText, EditorText, Ellipsis, RedText, SubTitle, Title, GuideText, Accessibility, MinorTitle};
